import * as React from 'react';
import "./Loader.css";

declare global {
  // tslint:disable-next-line
  interface Window {
    altibox: {
            commons: {
                showLoader: (cssSelector: string) => void;
                hideLoader: () => void;
            }
        };
  }
}

class Loader extends React.Component {
    public componentDidMount() {
        window.altibox.commons.showLoader('.loader_container');
    }

    public render() {
        return (
            <div className="loader_container"/>
        );
    }
}

export default Loader;